export const FunctionIconSize = {
  SMALL: 'small',
  LARGE: 'large',
};

export const IconSizeMap = {
  [FunctionIconSize.SMALL]: 20,
  [FunctionIconSize.LARGE]: 48,
};

export const FontSizeMap = {
  [FunctionIconSize.SMALL]: 16,
  [FunctionIconSize.LARGE]: 24,
};
